<template>
    <div>
        <div style="display: flex;margin-top: 20px;" @click="goOff()">
          <van-icon name="arrow-left" size="1.5em" />
          <span style="font-weight: 600;color: #000;">返回</span>
        </div>
        <div class="touyide">
            <div><img class="touxiang" :src="header" alt=""></div>
            <div>
                <p style="margin-left: 18px;">{{nick}}</p>
                <!-- <div class="tongbu">
                    <van-icon name="replay" style="margin-top: 8px;margin-left: 4px;" />
                    <span>同步微信信息</span>
                </div> -->
            </div>
        </div>
        <div class="xuexijilu">
           <div style="margin-left: 56px;">
              <p style="margin-top: 24px;">累计学习{{times}}</p>
              <p style="margin-top: 12px;" @click="xuexijilu()">听课记录</p>
           </div>
           <div style="margin-left: 82px;text-align: center;">
              <p style="margin-top: 24px;">{{nums}}</p>
              <p style="margin-top: 12px;" @click="yigoujilu()">我的已购</p>
           </div>
        </div>
    </div>
</template>
<script>
import qs from "qs";
	export default {
		data() {
			return {
        header: '',
        nick: '',
        nums: '',
        times: '',
			}
		},
		created(){
      this.infogeren()
			console.log('ggggggggggggg', this.$route.query.uid, this.$route.query.fans_id)
		},
		methods: {
      infogeren() {
        var that = this;
				this.axios.post('http://liveapi2.tenghuiwangxiao.com/api/ds/user/info', qs.stringify({ fansId: 1076933 }))
				.then(function(data){
			        if(data.data.code == "200") {
                that.header = data.data.data.header
                that.nick = data.data.data.nick
                that.nums = data.data.data.nums
                that.times = data.data.data.times
			        }
			    })
			},
      goOff(){
          this.$router.go(-1);
      },
      xuexijilu() {
				this.$router.push({'path':'/Learningrecord', query: {fans_id:this.$route.query.fans_id}});
			},
      yigoujilu() {
				this.$router.push({'path':'/MyPurchased', query:{fans_id:this.$route.query.fans_id}});
			},
		}
	}
</script>
<style scoped>
  .touyide {
    height: 68px;
    margin-top: 20px;
    display: flex;
  }
  .touxiang {
    width: 68px;
    height: 68px;
    border-radius: 34px;
    margin-left: 20px;
  }
  .tongbu {
    width: 110px;
    height: 30px;
    border: 1px silver solid;
    border-radius: 20px;
    margin-left: 12px;
    margin-top: 16px;
    display: flex;
    line-height: 30px;
  }
  .xuexijilu {
    width: 350px;
    height: 100px;
    margin: 0 auto;
    margin-top: 20px;
    border-radius: 4px;
    display: flex;
    border: 1px silver solid;
    /* background: lightblue; */
  }
</style>